import { makeStyles } from 'tss-react/mui';

type StyleParams = {
  isM1Enabled: boolean;
};

/** Styles for the panel zero-state surface (stacked copy and chip row). */
const useStyles = makeStyles<StyleParams>()((theme, { isM1Enabled }) => ({
  container: {
    display: 'flex',
    flex: isM1Enabled ? '0 0 auto' : 1,
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    gap: theme.new.spacing.xl,
    padding: isM1Enabled ? 0 : theme.new.spacing.medium,
    width: '100%',
    minHeight: 0,
  },
  topRegion: {
    display: 'flex',
    flex: 1,
    alignItems: 'flex-start',
    width: '100%',
    minHeight: 0,
  },
  copy: {
    ...theme.typography.body_regular,
    color: theme.new.color.textSecondary,
    margin: 0,
    width: '100%',
  },
  chipsRow: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: theme.new.spacing.small,
    width: '100%',
  },
}));

export default useStyles;
